module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp2_7016.cc58c784.png";